import useNotification from "component/global/event-handler/hooks/use-notification";
import useCodeScriptFunctionInput from "component/global/generic-hooks/use-code-script-fn-api";
import { useNavigate } from "react-router-dom";
import { emitRecordMutation } from "shared/services/recordMutationBus";
import { useSession } from "app/hooks/useSession";
import { useRecordListContext } from "./useRecordListContext";
import { executeRecordListScript } from "../services/executeRecordListScript";
import SysRecord from "app/class/record";

const useRecordListActionCompiler = () => {
    const { api } = useCodeScriptFunctionInput();
    const navigate = useNavigate();
    const notifyApi = useNotification();
    const { data: userSession } = useSession();
    const { table, selectedRows } = useRecordListContext();

    const actionContext = {
        ...api,
        ...notifyApi,
        currentUser: userSession,
        navigate
    };

    const runActionScript = async (action: SysRecord) => {
        try {
            const result = await executeRecordListScript(
                action.script,
                actionContext,
                selectedRows,
                table,
                "list",
                action.timeout_ms
            );

            if (table?.name && !result.mutatedTables.length) {
                emitRecordMutation({
                    table: table.name,
                    source: "record_list_action",
                });
            }
        } catch (error: any) {
            notifyApi.alert(
                "LIST-ACTION-ERROR",
                error?.message || "Error executing list action"
            );
            console.error("RecordListActionError:", error);
        }
    };

    return {
        runActionScript
    }
}

export default useRecordListActionCompiler;
